export default __webpack_public_path__ + "static/media/donor_3.b65f93f2.jpg";